import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { EntTypeProduct } from "../../models/handBooks/typeProduct";
import { EntTypeProductFilter } from "../../models/filters/TypeProductFilter";
import { getCookie } from "typescript-cookie";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetProductTypeListQuery } from "../../redux/api/handBooksApi/productTypesApi";

interface IProps {
  value?: number[] | null;
  onChange?: (value: number[]) => void;
  placeholder?: string;
}


const SelectMultiProductType = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetProductTypeListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntTypeProduct, EntTypeProductFilter>({
    initialFilter: new EntTypeProductFilter(),
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntTypeProductFilter();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntTypeProductFilter();
    filter.name = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
      <Select
        mode="multiple"
        placeholder={props.placeholder || t("msg.selectPlaceholder")}
        onClear={clear}
        onSearch={search}
        onPopupScroll={scrollHandler}
        loading={fetching}
        value={props.value}
        onChange={props.onChange}
        options={options}
        filterOption={defaultFilterOption}
        showSearch
        allowClear
        dropdownRender={(menu) => (
            <Spin spinning={fetching}>
              {menu}
            </Spin>
        )}
      />
  );
};

export default SelectMultiProductType;



